import { Link } from "react-router-dom";

interface CartFooterProps {
    total: number;
    onClose: () => void;
}

export function CartFooter({ total, onClose }: CartFooterProps) {
    return (
        <div className="p-6 border-t space-y-4 bg-stone-50">
            <div className="flex justify-between text-lg font-serif">
                <span>Subtotal</span>
                <span>£{total.toFixed(2)}</span>
            </div>
            <p className="text-xs text-stone-500">
                Shipping calculated at checkout.
            </p>
            <Link
                to="/checkout"
                onClick={onClose}
                className="block w-full bg-stone-900 text-white py-4 text-center hover:bg-stone-800 transition-colors uppercase tracking-widest text-sm"
            >
                Checkout
            </Link>
        </div>
    );
}
